import { render, staticRenderFns } from "./detailTabDetail.vue?vue&type=template&id=559c5cb1&scoped=true&"
import script from "./detailTabDetail.vue?vue&type=script&lang=js&"
export * from "./detailTabDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c5cb1",
  null
  
)

export default component.exports